var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 12623"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185edf",
    d: "M12.468 5.829h-2.3l.131-1.083c.2-1.608-.131-2.887-1.181-3.183h-.1a.656.656 0 0 0-.492.394S6.234 6.813 5.25 6.813H1.64a.656.656 0 0 0-.656.656v5.25a.656.656 0 0 0 .656.656h4.364a.525.525 0 0 1 .394.131 7.178 7.178 0 0 0 2.786 1.182h1.641c1.936 0 3.609-1.312 3.773-3.9l.164-2.658a2.2 2.2 0 0 0-2.3-2.3zm-10.172 2.3 1.969.001v3.933H2.297zm10.988 2.556c-.131 1.706-1.05 2.691-2.461 2.691H9.184a7.216 7.216 0 0 1-2-.919 1.9 1.9 0 0 0-1.18-.394h-.426V8.126c.623-.131 1.641-.722 3.445-4.2a5.315 5.315 0 0 1-.033.689l-.131 1.083-.164 1.444h3.773a.886.886 0 0 1 .984.952z",
    "data-name": "Path 16774"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.5c5e2c38fe1736bddbc19e52815f8bbb.svg";
export { ForwardRef as ReactComponent };